import React from 'react'
import { Create } from 'react-admin'
import Form from './form'
import { useTranslateResource } from '../../../hooks'

const TonnageTicketUploadsCreate = props => {
  const translate = useTranslateResource(props.resource, 'form')

  return (
    <Create {...props} >
      <Form saveButtonLabel={translate('actions.create')} />
    </Create>
  )
}

export default TonnageTicketUploadsCreate
